export default {
  state: {
    visibility: false
  },
  mutations: {
    SET_BUTTON_MENU_CARD_VISIBILITY(state, payload) {
      state.visibility = payload
    }
  }
}
